export function sendAppMessage(message) {
    const device = localStorage.getItem("device");
    const uniapp = localStorage.getItem("uniapp") || null;
    if(!device) return;
    if(device === "ard" || device === "android" || device === "pad") {
        window.android && window.android.jsCallAndroidArgs(JSON.stringify(message))
    }else if(device === "ios" && uniapp) {
        uni && uni.postMessage({data: message});
    } else if(device === "ios") {
        window.webkit && window.webkit.messageHandlers.jsToOcWithPrams.postMessage(message);
    }
}

export function checkLoginWidthAppMessage() {
    let token = localStorage.getItem("xxxxtoken");
    if(!token) {
        sendAppMessage({jump_type: 999, jump_url: ""});
    }
    return !!token;
}